import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  render() {
    return <header></header>;
  }
}
export class AdminHeader extends Component {
  render() {
    return (
      <header>
        <p>Admin Header</p>
      </header>
    );
  }
}

export default Header;
